import {OrderRequestStatus, TransactionResultType} from '../types/confirmationResult'

export interface RmcOrderRequestStatusData {
  status: OrderRequestStatus
  requestData?: {
    isConfirmedByCustomer?: boolean
    isConfirmedByDispatch?: boolean
    orderReason?: string
  }
  orderReason?: string
}

export interface RmcOrderRequestStatusResponse extends RmcOrderRequestStatusData {
  requestId: string
}

const CustomerActionRequiredReasons = new Set([
  'confirmedByUsUnconfirmedByCustomer',
  'unconfirmedByCustomer'
])

export const mapRmcOrderRequestStatus = ({
  status,
  requestData,
  orderReason: responseOrderReason
}: RmcOrderRequestStatusData): TransactionResultType => {
  if (status === OrderRequestStatus.Success) {
    const orderReason = requestData?.orderReason ?? responseOrderReason
    const isCustomerActionRequired =
      CustomerActionRequiredReasons.has(orderReason ?? '') &&
      requestData?.isConfirmedByCustomer === false &&
      requestData.isConfirmedByDispatch === false

    if (isCustomerActionRequired) {
      return 'customerActionRequired'
    }

    return requestData?.isConfirmedByDispatch ? 'success' : 'pendingDispatch'
  }

  if (status === OrderRequestStatus.Failed) {
    return 'failure'
  }

  return 'pending'
}
